
import { ContentTwoxOneNoImage } from "./styles";
import ContentTitle from "@/shared/ContentTitle";
import { LinkAbsolute } from "@/shared/LinkAbsolute";
import { NormalArticle } from "@/widgets/Nota/Templates/stylesModulesGenericNormal.js";
import { clickContent } from "@/shared/Analitics/GoogleAnalytics4";
import useNewsDataModules from "@/hooks/useNewsDataModules";

const TwoxOneNoImage = (props) => {
  const {
    asPath,
    author = [],
    authorSignature,
    containerName,
    payWallExclusive,
    relatedLilaNews,
    section = [],
    subtitle,
    summary,
    title,
    url,
    urlTarget,
  } = useNewsDataModules(props);   
  return (
    <NormalArticle suppressHydrationWarning>
      <ContentTwoxOneNoImage className="modulo2x1">
        <ContentTitle
          author={author}
          authorSignature={authorSignature}
          title={title}
          subtitle={subtitle}
          section={section}
          summary={summary}
          payWallExclusive={payWallExclusive}
          relatedLilaNews={relatedLilaNews}
        />
        <LinkAbsolute suppressHydrationWarning href={url} target={urlTarget} aria-label={title} onClick={() => clickContent({contentType: title, contentList: containerName},url,asPath)} />
      </ContentTwoxOneNoImage>
    </NormalArticle>
  );
};

export default TwoxOneNoImage;
